var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 12.008a7.5 7.5 0 10.001 15.001A7.5 7.5 0 0024 12.008zm-10.5 7.5c0-5.798 4.702-10.5 10.5-10.5s10.5 4.702 10.5 10.5-4.702 10.5-10.5 10.5-10.5-4.702-10.5-10.5z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 3.008c-9.114 0-16.5 7.386-16.5 16.5 0 7.428 3.253 13.256 6.983 17.507 3.737 4.258 7.893 6.862 9.515 7.79H24c1.621-.926 5.779-3.53 9.516-7.788 3.73-4.251 6.984-10.079 6.984-17.509 0-9.114-7.386-16.5-16.5-16.5zm-19.5 16.5c0-10.77 8.73-19.5 19.5-19.5s19.5 8.73 19.5 19.5c0 8.37-3.679 14.873-7.729 19.488-4.041 4.605-8.512 7.402-10.285 8.415h-.002c-.92.524-2.05.524-2.97 0h-.002c-1.774-1.014-6.243-3.812-10.284-8.418C8.178 34.378 4.5 27.876 4.5 19.508z","key":1})]);
}

Location.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Location;

Location.default = Location;
